/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PartNumberChangesDisplayComponentsTypeEnum {
    STICKY_HEADER = 'STICKY_HEADER',
    HEADER = 'HEADER',
    SECTION_TITLE = 'SECTION_TITLE',
    SOLUTION = 'SOLUTION',
    AI_SOLUTION = 'AI_SOLUTION',
    CREDENTIALS = 'CREDENTIALS',
    DIALOG_HISTORY_BUTTON = 'DIALOG_HISTORY_BUTTON',
    TRIALS = 'TRIALS',
    CURRENT_TRIAL = 'CURRENT_TRIAL',
    OLD_PART_NUMBER_CREATE = 'OLD_PART_NUMBER_CREATE',
    PNC_TYPE_SELECT = 'PNC_TYPE_SELECT',
    FOOTER = 'FOOTER',
    CANCELLED = 'CANCELLED',
    SOLUTION_TRIALS = 'SOLUTION_TRIALS'
}
